import {Card} from 'platform/components';
import {Box} from 'platform/foundation';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface ServiceCampaingVehiclesProps extends RequiredTestIdProps {
  serviceCampaignId: string;
}

export function ServiceCampaignVehicles(props: ServiceCampaingVehiclesProps) {
  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {manufacturerActionNumber: props.serviceCampaignId}]);

  return (
    <Card title={i18n.t('page.workshop.labels.campaignVehicles')}>
      <Box height={150}>
        <DmsDataGrid
          gridCode="service-campaign-hyundai-vehicles"
          data-testid={suffixTestId('serviceCampaignVehicleDataGrid', props)}
          queryModifier={queryModifier}
        />
      </Box>
    </Card>
  );
}
